// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incorrect-guesses-square {
  display: flex;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  font-size: xx-large;
  flex-direction: column;
  width: 33px;
  height: 33px;
}

.incorrect-guesses-heading {
  flex:1 1;
  margin-bottom: 1px;
  font-weight: 900;
}

.incorrect-guesses-container {
  margin: 1px;
  display: flex;
  flex-direction: column;
  justify-self: center;
  align-items: center;
  font-size: xx-small;
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/NewsiePreview/NewsieBottomBar/IncorrectGuesses/IncorrectGuesses.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,QAAM;EACN,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".incorrect-guesses-square {\n  display: flex;\n  border-radius: 5px;\n  justify-content: center;\n  align-items: center;\n  font-size: xx-large;\n  flex-direction: column;\n  width: 33px;\n  height: 33px;\n}\n\n.incorrect-guesses-heading {\n  flex:1;\n  margin-bottom: 1px;\n  font-weight: 900;\n}\n\n.incorrect-guesses-container {\n  margin: 1px;\n  display: flex;\n  flex-direction: column;\n  justify-self: center;\n  align-items: center;\n  font-size: xx-small;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
